import { H_RPQS_DASHBOARD, H_RPQS_OPTIONS } from 'account/constants/AccessRulesConstants'
import { ALIGN } from 'components/datatable/NewTable'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router'
import CollectivityAction from 'rpqs/actions/CollectivityAction'
import i18n from 'simple-react-i18n'

const CollectivityApp = () => {
    const { id } = useParams()
    const dispatch = useDispatch()

    const navLinks = useMemo(() => {
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/collectivity/rpqs/${id}/dashboard`,
            habilitation: H_RPQS_DASHBOARD,
        }, {
            icons: 'compare_arrows',
            name: i18n.descriptive,
            href: `/collectivity/rpqs/${id}/description`,
            habilitation: '',
        }, {
            icons: 'event',
            name: i18n.event,
            href: `/collectivity/rpqs/${id}/dashboard`,
            habilitation: '',
        }, {
            icons: 'perm_media',
            name: i18n.picturesAndDocuments,
            href: `/collectivity/rpqs/${id}/dashboard`,
            habilitation: '',
        }, {
            icons: 'insert_chart',
            name: i18n.statistics,
            href: `/collectivity/rpqs/${id}/dashboard`,
            habilitation: '',
        }, {
            icons: 'settings',
            name: i18n.settings,
            href: '/rpqs/option',
            habilitation: H_RPQS_OPTIONS,
            position: ALIGN.BOTTOM,
        }]
    }, [id])

    useEffect(() => {
        if (id !== 'new') {
            dispatch(CollectivityAction.fetchCollectivity(id))
        }
    }, [id, dispatch])

    return (
        <div className='row no-margin'>
            <FixedSlideNav links={navLinks}/>
            <main>
                <div className='row no-margin padding-left-1'>
                    <div className='content-page no-padding fullscreen'>
                        <BoundaryError>
                            <Outlet />
                        </BoundaryError>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default CollectivityApp
